import React, { useEffect, useCallback, useState } from 'react';
import useEmblaCarousel from 'embla-carousel-react';
import Fade from 'embla-carousel-fade';

interface DocumentationSlidesParams {
    imagesDesktop: string[];
    imagesMobile: string[];
}

const autoplayDelay = 3000;

const DocumentationSlides: React.FC<DocumentationSlidesParams> = ({ imagesDesktop, imagesMobile }) => {
    const [emblaRef, emblaApi] = useEmblaCarousel({ loop: true }, [Fade()]);
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const checkSize = () => {
            setIsMobile(window.innerWidth < 768);
        };
        checkSize();
        window.addEventListener("resize", checkSize);
        return () => window.removeEventListener("resize", checkSize);
    }, []);

    const images = isMobile ? imagesMobile : imagesDesktop;

    const autoplay = useCallback(() => {
        if (!emblaApi) return;
        if (emblaApi.canScrollNext()) {
            emblaApi.scrollNext();
        } else {
            emblaApi.scrollTo(0);
        }
    }, [emblaApi]);

    useEffect(() => {
        if (!emblaApi) return;
        const id = setInterval(autoplay, autoplayDelay);
        return () => clearInterval(id);
    }, [emblaApi, autoplay]);

    return (
        <div className="embla overflow-hidden h-96 w-screen mx-0" ref={emblaRef}>
            <div className="embla__container grid grid-flow-col auto-cols-[100%] h-full">
                {images.map((src, index) => (
                    <div
                        key={index}
                        className="embla__slide relative w-full h-full opacity-0 transition-opacity duration-100 ease-out"
                    >
                        <div className="absolute w-full h-full bg-darkBlue bg-opacity-50" />
                        <img className="w-full h-full object-cover" alt="" src={src} />
                    </div>
                ))}
            </div>
        </div>
    );
};

export default DocumentationSlides;
